module.exports = __webpack_public_path__ + "static/media/header__background.62afa0ac.png";